import React from 'react';
import { ArrowDownIcon, ArrowRightIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
import { withUtmParams } from '../utils/checkoutUrl';
interface CTAButtonProps {
  label: string;
  className?: string;
  /** Defaults to checkout. Pass an anchor (#offer) to scroll within the page. */
  href?: string;
  id?: string;
  variant?: 'primary' | 'ink' | 'light';
  arrow?: 'right' | 'down' | 'none';
  size?: 'md' | 'lg';
}

/** Single checkout destination for every purchase CTA. */
export const CHECKOUT_URL = 'https://catio-ready.impultienda.ar/checkout';
export function CTAButton({
  label,
  className = '',
  href = CHECKOUT_URL,
  id,
  variant = 'primary',
  arrow = 'right',
  size = 'md'
}: CTAButtonProps) {
  const goesToCheckout = href.startsWith(CHECKOUT_URL);
  const resolvedHref = goesToCheckout ? withUtmParams(href) : href;
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!goesToCheckout) return;
    trackInitiateCheckout();
    // Re-resolve at click time so the link always carries the visitor's UTMs.
    event.currentTarget.href = withUtmParams(href);
  };
  const palette = {
    primary:
    // Warm orange with a soft top highlight + inner edge for a tactile, lightly glossy feel.
    'bg-ember-cta text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.45),inset_0_10px_18px_-10px_rgba(255,214,180,0.55),inset_0_-2px_0_rgba(0,0,0,0.12),0_16px_30px_-14px_rgba(224,112,46,0.75)] hover:bg-ember-deep active:bg-ember-deep focus-visible:ring-ember-light/40',
    ink: 'bg-ink text-white shadow-[0_14px_26px_-14px_rgba(31,30,26,0.6)] hover:bg-ink-soft focus-visible:ring-ember/30',
    light: 'bg-paper text-ink hover:bg-stone focus-visible:ring-ember/30'
  }[variant];
  const dimensions = size === 'lg' ? 'min-h-[58px] px-8 text-[0.95rem] sm:text-[1rem]' : 'min-h-[52px] px-6 text-[0.88rem]';
  const Icon = arrow === 'down' ? ArrowDownIcon : ArrowRightIcon;
  return <a id={id} href={resolvedHref} onClick={handleClick} className={`group inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-[18px] text-center font-bold uppercase tracking-[0.05em] transition-[background-color,transform] duration-150 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-4 ${dimensions} ${palette} ${className}`} data-id="element-57" data-mp="2fuz5h2iejvnu">
      {label}
      {arrow !== 'none' && <Icon className={`h-[18px] w-[18px] shrink-0 transition-transform duration-200 ease-out ${arrow === 'down' ? 'group-hover:translate-y-0.5' : 'group-hover:translate-x-1'}`} strokeWidth={2.25} aria-hidden data-id="element-58" data-mp="28ynuhqolwua6" />}
    </a>;
}